<!--src/components/Common/TabbarSwitch.vue-->
<script setup>
import { defineProps, computed, watch, ref } from 'vue'
import { DEFAULT_TAB_LIST } from '@/config/tabConfig'
import { ThemeManager } from '@/utils/theme'
import {useRouter} from "vue-router";

const props = defineProps({
  tabList: {
    type: Array,
    default: () => DEFAULT_TAB_LIST
  },
  activeKey: {
    type: String,
    required: true
  }
})

const router = useRouter()
// const route = useRoute()

// 最终 Tab 列表（不变）
const finalTabList = computed(() => {
  return props.tabList.filter(tab => tab.key && tab.name && tab.path)
})

// 只通过路由路径判断选中态（恢复最初的正常逻辑）
const isActive = (tab) => {
  // 唯一判断依据：tab的key与外部传递的activeKey一致（与CommonHeader的activePlatform.key同步）
  return tab.key === props.activeKey
}


// 点击 Tab 只跳转路由，不依赖其他状态
const emit = defineEmits(['tabClick'])
const forceUpdate = ref(0)

const handleTabClick = (tab) => {
  router.push(tab.path)
  // 根据 Tab 的 key 或自定义字段匹配主题标识
  if (tab.theme) { // 假设 Tab 配置中添加了 theme 字段（如 theme: 'themeJdd'）
    ThemeManager.switchTheme(tab.theme)
  }
  emit('tabClick', tab)
}
watch(() => props.activeKey, () => {
  forceUpdate.value++
})

</script>

<template>
  <div
    v-if="finalTabList.length"
    class="tabbar-wrap d-flex justify-content-between align-items-center container"
    style="height: 60px;"
  >
    <div
      v-for="(tab, index) in finalTabList"
      :key="`tab-${tab.key}`"
      class="item flex-1 text-center position-relative mx-1"
      :class="{ 'active': isActive(tab) }"
      @click="handleTabClick(tab)"
    >
      <span>{{ tab.name }}</span>
    </div>
  </div>
</template>

<style scoped lang="scss">
/* 样式不变，保持最初的样子 */
@import "@/assets/css/mixin.scss";
.tabbar-wrap {
  background-color: #faf3fc !important;
  flex-wrap: nowrap;
  overflow: hidden !important;
  padding: 0 5.5rem 0 4rem !important;
  margin-top: 10px;
  border-top: 1px solid #dcdcdc;
}

.item {
  width: 8rem;
  height: 30px;
  color: #666 !important;
  font-size: 18px !important;
  font-weight: 500 !important;
  text-decoration: none !important;
  transition: all 0.3s ease !important;
  cursor: pointer;
  padding: 1rem 0 !important;
  background-color: #fff !important;
  border: 1px solid #eee !important;
  border-radius: 8px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  margin-top: 5px;

  &:hover {
    color: #dc3545 !important;
    @include border_color;
    transform: translateY(-2px) !important;
    box-shadow: 0 4px 8px rgba(220, 53, 69, 0.1) !important;
  }

  &.active {
    //color: #fff !important;
    font-weight: 600 !important;
    //background-color: red !important;
    @include bg_color();
    @include font_color();
    @include border_color
  }

}
@media (max-width: 991.98px) {
  .tabbar-wrap {
    //background: #3498db !important; // 加 !important 确保覆盖默认背景
    overflow-x: auto !important; // 横向滚动（之前适配需要）
    justify-content: flex-start !important;
    white-space: nowrap !important;
    padding: 0 10px !important;
    -webkit-overflow-scrolling: touch; // 移动端顺滑滚动
    &::-webkit-scrollbar {
      display: none !important; // Chrome/Safari 隐藏滚动条
    }
  }

  // 小屏时 .item 样式微调（可选）
  .item {
    width: auto !important; // 取消固定宽度，自适应文字
    min-width: 4.5rem !important; // 只设最小宽度，避免过窄
    font-size: 14px !important;
    margin: 0 5px !important;
    flex: 0 0 auto !important; // 禁止伸缩，保持自身宽度

  }
}

@media (min-width: 992px) {

}
</style>
